export function normalizeMacroName(input) {
    if (input === null || input === undefined) return ""
    const raw = `${input}`.trim()
    if (!raw) return ""
    const withoutToken = raw.startsWith("$") ? raw.slice(1) : raw
    return withoutToken
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
}

export const MACRO_NAME_MAX_LENGTH = 32
export const MACRO_NAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
export const MACRO_NAME_ERROR = "Name can only contain letters, numbers, and hyphens (max 32 characters)."

export function isValidMacroName(input) {
    const normalized = normalizeMacroName(input)
    if (!normalized) return false
    if (normalized.length > MACRO_NAME_MAX_LENGTH) return false
    return MACRO_NAME_PATTERN.test(normalized)
}

export function macroNameYup(value, yup) {
    return yup
        .string()
        .trim()
        .required("Macro name is required")
        .test("macro-name", MACRO_NAME_ERROR, isValidMacroName)
        .validateSync(value)
}

export function sanitizeMacroLinks(links = []) {
    if (!Array.isArray(links)) throw new Error(`Macro links must be an array`)
    const sanitized = [...new Set(links)]
    return sanitized
}
